import { Input as AntdInput, Form } from 'antd'
import Label from 'components/Form/Label'
import React from 'react'
import styled from 'styled-components'
import { FONT } from 'theme/font'

const { Item } = Form

const StyledItem = styled(Item)`
  > div {
    width: 100%;
    text-align: left;
    ${props =>
      props.hasBorderRight &&
      css`
        border-right: 1px solid #e6e7ea !important;
        height: 50px !important;
      `}
  }
  border-radius: 8px;
  margin-bottom: 0px !important;
  background: ${props => (props.background ? props.background : '')};
`
const AntdInputStyle = styled(AntdInput)`
  ::placeholder {
    font-size: 16px;
  }
  height: ${props => (props.height ? props.height : '48px')};
  padding: ${props => (props.padding ? props.padding : '')};
  border-radius: 8px;
  box-shadow: none;
  border-color: ${props => (props.error ? 'red' : '#e9e9e9')};
  :focus {
    border-color: #e9e9e9;
    box-shadow: none;
  }
  :hover {
    border-color: #e9e9e9;
  }
  :not(.ant-input-affix-wrapper-disabled):hover {
    border-color: #e9e9e9 !important;
  }
  .ant-input-affix-wrapper-focused {
    box-shadow: none;
    border-right-width: 0px !important;

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
`
const Notice = styled.div`
  margin-top: 10px;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_XS};
  line-height: 15px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #cccfd6;
`
const Input = ({
  label,
  type,
  name,
  rules,
  onChange,
  placeholder,
  required,
  disabled,
  width = '552px',
  height,
  marginRight,
  labelStyle,
  defaultValue,
  optional,
  noStyle = undefined,
  notice,
  dependencies,
  padding,
  background,
  hasBorderRight,
  ...rest
}) => {
  return (
    <>
      <StyledItem
        style={{
          width: width,
          marginRight: marginRight,
        }}
        background={background}
        rules={rules}
        noStyle={noStyle}
        name={name}
        colon={false}
        required={false}
        dependencies={dependencies}
        label={
          label && (
            <Label required={required} labelStyle={labelStyle}>
              {label} <span>{optional}</span>
            </Label>
          )
        }
        hasBorderRight={hasBorderRight}
      >
        <AntdInputStyle
          {...rest}
          defaultValue={defaultValue}
          type={type}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          height={height}
          padding={padding}
        />
      </StyledItem>
      {notice && <Notice>{notice}</Notice>}
    </>
  )
}
export default Input
